import { render, staticRenderFns } from "./AppleStoreBtn.vue?vue&type=template&id=2cfdd8b5&scoped=true&"
import script from "./AppleStoreBtn.vue?vue&type=script&lang=js&"
export * from "./AppleStoreBtn.vue?vue&type=script&lang=js&"
import style0 from "./AppleStoreBtn.vue?vue&type=style&index=0&id=2cfdd8b5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfdd8b5",
  null
  
)

export default component.exports